import * as React from 'react';
export function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = React.useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      if (item) {
        const test = item.match(/^(\[|\{|\d).*(\]|\}|\d)?$/gm);
        if (test && test.length) {
          return JSON.parse(item);
        } else {
          return item;
        }
      } else {
        return initialValue;
      }
    } catch (error) {
      return initialValue;
    }
  });
  const setValue = React.useCallback(value => {
    try {
      setStoredValue(value);
      if (typeof value === 'object') {
        window.localStorage.setItem(key, JSON.stringify(value));
      } else {
        window.localStorage.setItem(key, value);
      }
    } catch (error) {
      console.error(error);
    }
  }, [key]);
  return [storedValue, setValue];
}